/* istanbul ignore file */

import { batch, connect } from 'react-redux';

import { actions as filterActions } from 'src/components/organisms/Filter/modules/slice';
import { ReduxApplicationState } from 'src/redux/combinedReducer';
import { updateFilters, UpdateFiltersActionType } from 'src/redux/products';
import { selectFilterOptions, selectSelectedFilterOptions } from 'src/redux/products/selectors';
import { AppThunkDispatch } from 'src/redux/store';
import { SelectedFilterOption } from 'src/types';
import { QuickFilters, QuickFiltersProps } from '../components/QuickFilters';

const mapStateToProps = (state: ReduxApplicationState, ownProps: QuickFiltersProps) => ({
  filterLinks: selectFilterOptions(state, ownProps.filterUid),
  selectedFilterOptions: selectSelectedFilterOptions(state, ownProps.filterUid),
});

const mapDispatchToProps = (dispatch: AppThunkDispatch) => ({
  onSelectFilterOption: (selectedFilterOption: SelectedFilterOption) => {
    batch(() => {
      dispatch(filterActions.selectFilterOption(selectedFilterOption));
      dispatch(updateFilters(UpdateFiltersActionType.FILTER));
    });
  },
});

export const QuickFiltersContainer = connect(mapStateToProps, mapDispatchToProps)(QuickFilters);
